import { render, staticRenderFns } from "./CY_Place.vue?vue&type=template&id=05b05b86&scoped=true"
import script from "./CY_Place.vue?vue&type=script&lang=js"
export * from "./CY_Place.vue?vue&type=script&lang=js"
import style0 from "./CY_Place.vue?vue&type=style&index=0&id=05b05b86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b05b86",
  null
  
)

export default component.exports